// extracted by mini-css-extract-plugin
export default {"preview":"m24NNQ7W"};